import { NgModule, ModuleWithProviders } from "@angular/core";

import { PharmacyLookupServiceInterface } from "./pharmacy-lookup-service-interface.service";

@NgModule()
export class PharmacyLookupModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: PharmacyLookupModule,
      providers: [
        PharmacyLookupServiceInterface
      ]
    };
}}




// WEBPACK FOOTER //
// D:/a/29/s/PDMI.PharmacyLocator.Web/src/widgets/pharmacy-lookup/pharmacy-lookup.module.ts